<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="$t('Modify') + ' ' + $t('a.intervention')"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <b-form @submit.stop.prevent="onSubmit">

            <!--region address-->
            <div class="row">
              <div class="col-lg-8 col-sm-12">
                <SelectAutoCompleteField
                  :title="$t('AddressIntervention')+'*'"
                  :urlData="'/addressIntervention/getSuggestions?word='"
                  @setTagValue="setAddressIntervention"
                  :initValue="addressIntervention"
                >
                </SelectAutoCompleteField>
              </div>
              <div class="col-lg-4 col-sm-12 d-flex align-items-center justify-content-end">
                <b-form-group label=" ">
                  <b-button @click="showCreateAddressInterventionModal" type="button" variant="thirdly" >+ {{$t('new.intervention.address')}} </b-button>
                </b-form-group>
              </div>
            </div>
            <div class="line-separator mb-3"></div>

            <!--endregion-->
            <!--region Infos-->
            <div class="row">
              <b-form-group
                id="type-input"
                :label="$t('intervention.Type')+'*'"
                label-for="type-input"
                class="bold-label col-12 col-md-6 mb-4"
                :invalid-feedback="form.type.invalidFeedback"
                :state="form.type.state"
              >
                <b-form-select
                  id="type-input"
                  v-model="form.type.value"
                  :options="interventionTypes"
                  :state="form.type.state"
                  required
                ></b-form-select>
              </b-form-group>

              <b-form-group
                id="technician-input"
                :label="$t('intervention.Technician')+'*'"
                label-for="technician-input"
                class="bold-label col-12 col-md-6 mb-4"
                :invalid-feedback="form.technician.invalidFeedback"
                :state="form.technician.state"
              >
                <b-form-select
                  id="technician-input"
                  v-model="form.technician.value"
                  :options="technicians"
                  :state="form.technician.state"
                  required
                ></b-form-select>
              </b-form-group>

              <b-form-group
                id="applicant-input"
                :label="$t('Applicant')+'*'"
                label-for="applicant-input"
                class="bold-label col-12 col-md-6 mb-4"
                :invalid-feedback="form.applicant.invalidFeedback"
                :state="form.applicant.state"
              >
                <b-form-select
                  id="applicant-input"
                  v-model="form.applicant.value"
                  :options="applicantOptions"
                  :state="form.applicant.state"
                  :disabled="applicantOptions.length <= 1"
                  required
                ></b-form-select>
              </b-form-group>

              <b-form-group
                id="device-input"
                :label="$t('device.concerned')"
                label-for="device-input"
                class="bold-label col-12 col-md-6 mb-4"
                :invalid-feedback="form.device.invalidFeedback"
                :state="form.device.state"
              >
                <b-form-select
                  id="technician-input"
                  v-model="form.device.value"
                  :options="deviceOptions"
                  :state="form.device.state"
                  :disabled="deviceOptions.length <= 1"
                ></b-form-select>
              </b-form-group>

              <date-field
                :dateName="$t('intervention.StartDate')"
                :isRequired="true"
                @dateInfos="getEstimatedStartDateInfos"
                :init-value="initValueEstimatedStartDate"
              >
              </date-field>

              <date-field
                :dateName="$t('intervention.EndDate')"
                :isRequired="true"
                @dateInfos="getEndDateInfos"
                :init-value="initValueEndDate"
              >
              </date-field>

              <b-form-group
                id="description-input"
                :label="$t('intervention.Description')"
                label-for="description-input"
                class="bold-label col-12 mb-4"
                :invalid-feedback="form.description.invalidFeedback"
                :state="form.description.state"
              >
                <b-form-textarea
                  id="description-input"
                  v-model="form.description.value"
                  type="text"
                  maxlength="5000"
                  :state="form.description.state"
                ></b-form-textarea>
              </b-form-group>
            </div>
            <div class="line-separator mb-3"></div>
            <!--endregion-->
            <!--region billing address-->
            <div class="row">
              <div class="col-12">
                <b-form-group
                  id="billingAddress-input"
                  :label="$t('applicant.address')+'*'"
                  label-for="billingAddress-input"
                  class="bold-label"
                  :invalid-feedback="form.billingAddress.invalidFeedback"
                  :state="form.billingAddress.state"
                >
                  <b-form-input
                    id="billingAddress-input"
                    :placeholder="$t('number.and.address')"
                    v-model="form.billingAddress.value"
                    type="text"
                    maxlength="250"
                    :state="form.billingAddress.state"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-12">
                <b-form-group
                  id="billingAdditionalAddress-input"
                  :label="$t('addressIntervention.AdditionalAddress')"
                  label-for="billingAdditionalAddress-input"
                  class="bold-label"
                  :invalid-feedback="form.billingAdditionalAddress.invalidFeedback"
                  :state="form.billingAdditionalAddress.state"
                >
                  <b-form-input
                    id="billingAdditionalAddress-input"
                    :placeholder="$t('addressIntervention.AdditionalAddress')"
                    v-model="form.billingAdditionalAddress.value"
                    type="text"
                    maxlength="250"
                    :state="form.billingAdditionalAddress.state"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group
                  id="billingPostalCode-input"
                  :label="$t('addressIntervention.postalCode')+'*'"
                  label-for="billingPostalCode-input"
                  class="bold-label"
                  :invalid-feedback="form.billingPostalCode.invalidFeedback"
                  :state="form.billingPostalCode.state"
                >
                  <b-form-input
                    id="billingPostalCode-input"
                    :placeholder="$t('addressIntervention.postalCode')"
                    v-model="form.billingPostalCode.value"
                    type="text"
                    maxlength="250"
                    :state="form.billingPostalCode.state"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group
                  id="billingCity-input"
                  :label="$t('addressIntervention.city')+'*'"
                  label-for="billingCity-input"
                  class="bold-label"
                  :invalid-feedback="form.billingCity.invalidFeedback"
                  :state="form.billingCity.state"
                >
                  <b-form-input
                    id="billingCity-input"
                    :placeholder="$t('addressIntervention.city')"
                    v-model="form.billingCity.value"
                    type="text"
                    maxlength="250"
                    :state="form.billingCity.state"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <b-form-checkbox
                    id="recordBillingToApplicant-input"
                    v-model="form.recordBillingToApplicant.value"
                    :state="form.recordBillingToApplicant.state"
                  >
                    <div> {{$t('record.billing.to.applicant')}}</div>
                  </b-form-checkbox>
                </div>
              </div>
            </div>
            <div class="line-separator mb-3 mt-2"></div>
            <!--          endregion-->
            <!--region Documents -->
          <div class="row">
            <div class="col-6">
              <!--region ajout de document-->
              <b-form-group
                class="bold-label"
                label="Photo ou document"
                label-for="file-input"
              >
                <b-form-file
                  id="file-input"
                  class="mt-1"
                  accept="image/jpeg, image/png, .pdf, .docx, .odt, .doc"
                  placeholder="Photo ou document..."
                  drop-placeholder="Glisser le fichier ici"
                  v-model="file.value"
                ></b-form-file>
              </b-form-group>

              <div v-if="this.file.preview != null">
                <div v-if="this.file.type === 'PHOTO'" class="mt-2 position-relative text-right">
                  <b-button @click="addFile" class="btn-icon add-photo-icon">
                    <device-floppy-icon/>
                  </b-button>
                  <b-button @click="removeFile" class="btn-icon remove-photo-icon">
                    <trash-icon/>
                  </b-button>
                  <img
                    class="preview"
                    :src="this.file.preview"
                    alt="Aperçu"
                  >
                </div>

                <div v-if="this.file.type === 'DOCUMENT'" class="mt-2 position-relative">
                  <file-text-icon/>
                  <a :href=this.file.preview target="_blank">{{ this.file.value.name }}</a>
                  <b-button @click="addFile" class="btn-icon add-photo-icon document">
                    <device-floppy-icon/>
                  </b-button>
                  <b-button @click="removeFile()" class="btn-icon remove-photo-icon document">
                    <trash-icon/>
                  </b-button>
                </div>
              </div>
              <!--endregion-->
              <!--region pdf des appareils-->
              <div v-if="pdfEditables && pdfEditables.length > 0" class="bold-text main-color mt-4 mb-2">
                <!--region linked to device-->
                {{ $t('DeviceDocuments') }}
                <div v-for="device in devices" class="mr-0 mr-lg-2 mb-2 mb-lg-0 flex">
                  <div class="bold-text black-text mt-2 mb-2 ml-2" v-if="pdfEditables.findIndex(item => item.device != null && item.device.id === device.id) !== -1">
                    {{ device.name }}
                  </div>
                  <div v-for="fileIntervention in pdfEditables">
                    <div v-if="fileIntervention.device != null && fileIntervention.device.id === device.id" class="mb-2" style="display: flex;flex-wrap: wrap">
                      <div class="col-1">
                        <file-text-icon size="28"/>
                      </div>
                      <a :href=fullFileUrl(fileIntervention.fileUrl) class="text-document col-10" target="_blank">{{ fileIntervention.name }}</a>
                      <button @click="removeFileDB(fileIntervention)" class="btn-icon remove-photo-icon listFile document">
                        <trash-icon size="25"/>
                      </button>
                    </div>
                  </div>
                </div>
                <!--endregion-->
                <!--region not linked to device-->
                <div class="bold-text black-text mt-2 mb-2 ml-2" v-if="pdfEditables.findIndex(item => item.device == null) !== -1">
                  {{ $t('NoDeviceDocuments') }}
                </div>
                <div v-for="fileIntervention in pdfEditables">
                  <div v-if="fileIntervention.device == null" class="mb-2" style="display: flex;flex-wrap: wrap">
                    <div class="col-1">
                      <file-text-icon size="28"/>
                    </div>
                    <a :href=fullFileUrl(fileIntervention.fileUrl) class="text-document col-10" target="_blank">{{ fileIntervention.name }}</a>
                    <button @click="removeFileDB(fileIntervention)" class="btn-icon remove-photo-icon listFile document">
                      <trash-icon size="25"/>
                    </button>
                  </div>
                </div>
                <!--endregion-->
                <hr>
              </div>
              <!--endregion-->
              <!--region DOCUMENTS-->
              <div v-if="fileInterventions && fileInterventions.length>0" class="bold-text main-color mt-4 mb-4">
                {{ $t("Documents") }}
                <div v-for="fileIntervention in fileInterventions" class="mr-0 mr-lg-2 mb-2 mt-2 mb-lg-0 flex">
                  <div v-if="fileIntervention.type === 'DOCUMENT'"
                       class="mb-2" style="display: flex;flex-wrap: wrap">
                    <div class="col-1">
                      <file-text-icon size="28"/>
                    </div>
                    <a :href=fullFileUrl(fileIntervention.fileUrl) class="text-document col-10" target="_blank">{{ fileIntervention.name }}</a>
                    <b-button @click="removeFileDB(fileIntervention)" class="btn-icon remove-photo-icon listFile document col-1">
                      <trash-icon size="25"/>
                    </b-button>
                  </div>
                </div>
                <hr>
              </div>
              <!-- endregion   -->
              <!--region PHOTOS -->
              <div v-for="fileIntervention in fileInterventions" class="mr-0 mr-lg-2 mb-2 mb-lg-0">
                <div v-if="fileIntervention.type === 'PHOTO'" class="mb-2">
                  <b-button @click="removeFileDB(fileIntervention)" class="btn-icon remove-photo-icon listFile">
                    <trash-icon/>
                  </b-button>
                  <img
                    style="width: 100%"
                    :src="fullFileUrl(fileIntervention.fileUrl)"
                    @click="zoomOnImage(fullFileUrl(fileIntervention.fileUrl))"
                    alt="Photo associée à la note"
                    class="note-img"
                  >
                </div>
              </div>
              <!--endregion-->
            </div>

<!--endregion-->

            <div class="d-flex justify-content-end col-md-12" style="flex: auto; align-items: flex-start;">
              <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
            </div>
          </div>
        </b-form>
      </b-card>
    </b-container>

    <AddressInterventionCreateModal @didCreateAddressIntervention="didCreateAddressIntervention"></AddressInterventionCreateModal>
    <!-- Modal Delete -->
    <file-intervention-delete-modal :file="fileIntervention" @didDeleteFileIntervention="didRemoveFileDB()"></file-intervention-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import DateField from "../../components/b122/DateField";
import {dateUtils} from "../../mixins/utils";
import SelectAutoCompleteField from "../../components/SelectAutoCompleteField";
import AddressInterventionCreateModal from "../addressIntervention/AddressInterventionCreateModal";
import FileInterventionDeleteModal from "./FileInterventionDeleteModal";
import _ from "lodash";

export default {

  name: 'InterventionEdit',

  mixins: [dateUtils],

  components: {
    BackArrow,
    DateField,
    SelectAutoCompleteField,
    FileInterventionDeleteModal,
    AddressInterventionCreateModal,
  },

  data() {
    return {
      interventionId: this.$route.params.interventionId,
      addressIntervention: null,
      intervention: {},
      initValueEstimatedStartDate: null,
      initValueEndDate: null,
      modelConfig: {
        type: 'number',
        timeAdjust: '10:00:00'
      },
      technicians: [],
      addressInterventions: [],
      interventionTypes: [],
      applicant: null,
      applicantOptions: [],
      deviceOptions: [],
      devices: [],
      fileInterventions: [],
      pdfEditables:[],
      fileIntervention: null,
      ui: {
        zoomOnImageSrc: null
      },
      file: {
        value: null,
        type: null,
        preview: null
      },
      form: {
        technician: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        applicant:{
          state: null,
          invalidFeedback: null,
          value: null
        },
        device: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        description: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        estimatedEndDate: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        estimatedStartDate: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        type: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        billingAddress:{
          state: null,
          invalidFeedback: null,
          value: null
        },
        billingPostalCode:{
          state: null,
          invalidFeedback: null,
          value: null
        },
        billingCity:{
          state: null,
          invalidFeedback: null,
          value: null
        },
        billingAdditionalAddress:{
          state: null,
          invalidFeedback: null,
          value: null
        },
        recordBillingToApplicant:{
          state: null,
          invalidFeedback: null,
          value: false
        },
      }
    }
  },

  mounted() {
    this.fetchData()
  },

  watch: {
    'addressIntervention':function () {
      this.deviceOptions = [{value: null, text: this.$i18n.t('device.select'), disabled: true}]
      this.applicantOptions = [{value: null, text: this.$i18n.t('applicant.select'), disabled: true}]
      if(this.addressIntervention != null){
        if(this.addressIntervention.tenant != null) this.applicantOptions.push({value: this.addressIntervention.tenant.id, text: this.addressIntervention.tenant.name})
        if(this.addressIntervention.owner != null) this.applicantOptions.push({value: this.addressIntervention.owner.id, text: this.addressIntervention.owner.name})
        if(this.addressIntervention.agency != null) this.applicantOptions.push({value: this.addressIntervention.agency.id, text: this.addressIntervention.agency.name})
        this.fetchDevices()
      }
      // this.form.billingAddress.value = null;
      // this.form.billingPostalCode.value = null;
      // this.form.billingCity.value = null;
      // this.form.billingAdditionalAddress.value = null;
    },
    'form.applicant.value': function () {
      // this.form.billingAddress.value = null
      // this.form.billingPostalCode.value  = null
      // this.form.billingCity.value  = null
      // this.form.billingAdditionalAddress.value  = null
      this.fetchApplicantAddress()
    },
    'file.value'() {
      if (this.file.value) {
        this.didAddFile()
      }
    }
  },

  methods: {
    //region fetch
    fetchData() {
      this.fetchIntervention()
      this.fetchTechnicians()
      this.fetchInterventionTypes()
    },

    fetchIntervention() {
      api
          .get(`/intervention/${this.interventionId}`)
          .then(response => {
            this.intervention = response.data
            this.setInitialValues()
            this.fetchDevices()
            this.fetchFileInterventions()
          })
    },

    fetchTechnicians() {
      api
        .get(`/technician`)
        .then(response => {
          this.technicians = [{value: null, text: this.$i18n.t('TechnicianSelect'), disabled: true}]
          response.data.map(technician => {
            this.technicians.push({value: technician.id, text: technician.name})
          })
        })
    },

    fetchDevices() {
       api
        .get(`/device/getDevicesByAddressIntervention?addressInterventionId=${this.addressIntervention.id }`)
        .then(response => {
          this.deviceOptions = [{value: null, text: this.$i18n.t('device.select'), disabled: true}]
          this.devices = response.data
          response.data.map(device => {
            if(device != null){
              this.deviceOptions.push({value: device.id, text: device.name})
            }
          })
        })
    },

    fetchFileInterventions() {
      api
        .get(`/fileIntervention/getFileInterventionsByInterventionId?interventionId=${this.intervention.id}`)
        .then(response => {
          this.fileInterventions = response.data
          // Enlève les valeurs de fileIntervention que l'on veut retrouver dans pdfEditable ;)
          this.pdfEditables = _.remove(this.fileInterventions, (value)=>{
            return value.type === "PDF_EDITABLE"
          })
        })
    },

    fetchInterventionTypes(){
      api
        .get(`/interventionType`)
        .then(response => {
          this.interventionTypes.push({value: null, text: this.$i18n.t('TypeSelect'), disabled: true})
          response.data.map(interventionType => {
            this.interventionTypes.push({value: interventionType.id, text: this.$i18n.t(interventionType.slug_key)})
          })
        })
    },

    fetchApplicantAddress(){
      api
        .get(`/client/${this.form.applicant.value}`)
        .then(response => {
          this.applicant = response.data
          if(this.applicant.address != null){
            this.form.billingAddress.value = this.applicant.address
            this.form.billingPostalCode.value  = this.applicant.postalCode
            this.form.billingCity.value  = this.applicant.city
            this.form.billingAdditionalAddress.value  = this.applicant.additionalAddress
          }
        })
    },
    //endregion

    getEstimatedStartDateInfos(state, invalidFeedBack, value) {
      this.form.estimatedStartDate.state = state;
      this.form.estimatedStartDate.invalidFeedback = invalidFeedBack;
      this.form.estimatedStartDate.value = value;

      if(new Date(this.form.estimatedStartDate.value).getTime() !== this.intervention.estimatedStartDate ) {
        this.initValueEndDate = new Date(value + 3600000);
      }
    },

    getEndDateInfos(state, invalidFeedBack, value) {
      this.form.estimatedEndDate.state = state;
      this.form.estimatedEndDate.invalidFeedback = invalidFeedBack;
      this.form.estimatedEndDate.value = value;
    },

    setAddressIntervention(addressIntervention){
      this.addressIntervention=addressIntervention
    },

    showCreateAddressInterventionModal(){
      this.$bvModal.show('addressIntervention-create-modal')
    },

    didCreateAddressIntervention(response){
      this.setAddressIntervention(response)
      this.$bvModal.hide('addressIntervention-create-modal')
    },

    setInitialValues() {
      this.addressIntervention = this.intervention.addressIntervention
      this.form.applicant.value = this.intervention.applicant.id
      this.form.device.value = this.intervention.device != null ? this.intervention.device.id : null
      this.form.type.value = this.intervention.type.id
      this.form.technician.value = this.intervention.technician.id
      this.form.estimatedEndDate.value = this.intervention.estimatedEndDate
      this.form.estimatedStartDate.value = this.intervention.estimatedStartDate
      this.form.description.value = this.intervention.description
      this.initValueEstimatedStartDate = new Date(this.intervention.estimatedStartDate)
      this.initValueEndDate = new Date(this.intervention.estimatedEndDate)
      this.form.billingAddress.value = this.intervention.billingAddress.address
      this.form.billingAdditionalAddress.value = this.intervention.billingAddress.additionalAddress
      this.form.billingPostalCode.value = this.intervention.billingAddress.postalCode
      this.form.billingCity.value = this.intervention.billingAddress.city
    },

    onSubmit() {
      if (this.form.estimatedStartDate.value >= this.form.estimatedEndDate.value) {
        this.$bvToast.toast(this.$i18n.t("problemDate"), {
          autoHideDelay: 20000,
          toaster: 'b-toaster-top-center'
        })
        return
      }
      if(!this.addressIntervention){
        return
      }
      let data = new FormData()
      data.append('typeId', this.form.type.value)
      data.append('technicianId', this.form.technician.value)
      data.append('addressInterventionId', this.addressIntervention.id)
      data.append('applicantId', this.form.applicant.value)
      if(this.form.device.value){
        data.append('deviceId', this.form.device.value)
      }
      data.append('estimatedEndDate', new Date( this.form.estimatedEndDate.value).getTime() - 1)
      data.append('estimatedStartDate', new Date( this.form.estimatedStartDate.value).getTime())
      if (this.form.description.value && this.form.description.value.trim() !== "") {
        data.append('description', this.form.description.value)
      }

      data.append('billingAddress', this.form.billingAddress.value)
      data.append('billingPostalCode', this.form.billingPostalCode.value)
      data.append('billingCity', this.form.billingCity.value)
      if(this.form.billingAdditionalAddress.value && this.form.billingAdditionalAddress.value.trim() !== ""){
        data.append('billingAdditionalAddress', this.form.billingAdditionalAddress.value)
      }
      data.append('recordBillingToApplicant', this.form.recordBillingToApplicant.value)


      api({
        method: 'POST',
        url: `/intervention/${this.intervention.id}`,
        data: data
      })
          .then((response) => {
            this.$router.push({
              name: 'InterventionShow',
              params: {
                interventionId: this.intervention.id
              }
            }, () => {
              this.$nextTick(() => {
                let interventionName = this.formatDate(this.form.estimatedStartDate.value)
                this.successToast(interventionName)
              })
            })
          })
          .catch((error) => {
            if (error.response.status === 418) {
              const invalidField = error.response.data.invalidField
              this.form[invalidField]["state"] = false
              this.form[invalidField]["invalidFeedback"] = error.response.data.message
            }else if(error.response.status === 420){
              alert(error.response.data.message)
            }
          });
    },

    successToast(interventionName) {
      this.$bvToast.toast(this.$i18n.t('Intervention') + ' "' + interventionName + '" ' + this.$i18n.t('modify'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    didAddFile() {
      this.file.preview = URL.createObjectURL(this.file.value)
      let extension = this.checkExtension(this.file.value.name).toUpperCase();
      this.file.type = (extension !== "JPG" && extension !== "JPEG" && extension !== "PNG") ? "DOCUMENT" : "PHOTO"
    },

    checkExtension(filename) {
      return filename.split('.').pop();
    },

    removeFile() {
      this.file.preview = null;
      this.file.type = null;
      this.file.value = null;
      this.file.state = null;
      this.file.invalidFeedback = null;
    },

    fullFileUrl(fileUrl) {
      return process.env.SERVER_URL + fileUrl
    },

    zoomOnImage(imageSrc) {
      this.ui.zoomOnImageSrc = imageSrc
    },

    didCloseZoomOnImage() {
      this.ui.zoomOnImageSrc = null
    },

    removeFileDB(file){
      this.fileIntervention = file
      this.$bvModal.show('file-intervention-delete-modal')
    },

    didRemoveFileDB(){
      this.fetchFileInterventions()
    },

    addFile() {
      var headers = { 'content-type': 'multipart/form-data' }

      let data = new FormData()
      if (this.file.value) {
        data.append('file', this.file.value)
      }
      data.append('interventionId', this.intervention.id)

      api({
        method: 'POST',
        url: `fileIntervention/addFileIntervention`,
        data: data,
        headers: headers
      }).then((response) => {
        this.removeFile()
        this.fetchFileInterventions()
      })
    },
  }
}
</script>

<style scoped>
.black-text{
  color: var(--main-text-color);
}
</style>



// WEBPACK FOOTER //
// src/views/intervention/InterventionEdit.vue